import { FC } from "react";
import { useTranslation } from "react-i18next";
import Carrier from "@Components/Carrier/Carrier";
import { FiltersIcon } from "src/assets/Icons";
import FiltersBarContent, { FiltersBarContentProps } from "../components/FiltersBarContent";
import { Badge } from "antd";

const FiltersBarMob: FC<FiltersBarContentProps> = (props) => {
  const { t } = useTranslation();
  const { dataCount, isFetching } = props;

  return (
    <Carrier
      label={t("Hotels.listing.filters")}
      renderTrigger={({ open }) => (
        <Badge
          count={isFetching ? 0 : dataCount?.segmentCount}
          color={"var(--color-primary-60)"}
          showZero
        >
          <div
            onClick={open}
            className="bg-background-minimal! outline-border-default! p-4! outline! flex h-full items-center justify-center rounded-md"
          >
            <FiltersIcon />
          </div>
        </Badge>
      )}
      renderSheet={() => (
        <div className="flex flex-col p-5 gap-3 overflow-y-auto">
          <FiltersBarContent {...props} />
        </div>
      )}
    />
  );
};

export default FiltersBarMob;
